/**
 * DesignSystem — a named bundle of (default Brand, base Tokens). `generate()`
 * starts from `defaultTokens` and overrides the Brand-driven groups; the rest
 * (shadows, weights, etc.) are the design system's own taste.
 *
 * This interface is the SEAM: `duro` is the first/default implementation, and a
 * future BYO/custom design system (incl. the Phase-4 code path) implements the
 * same contract — plus, later, web/native `styleMap`s for placed components.
 *
 * Design systems must be BUNDLED (offline-available) — free mode has no server.
 */
import type { BrandInputs } from "./brand.js";
import type { Tokens } from "./tokens.js";

export interface DesignSystem {
  readonly id: string;
  readonly name: string;
  /** Starting Brand a new site gets when it selects this design system. */
  readonly defaultBrand: BrandInputs;
  /** Base tokens; `generate()` keeps the non-Brand-driven groups from here. */
  readonly defaultTokens: Tokens;
  // Phase 2 will add: styleMap(web) / styleMap(native) for placed primitives.
}

const registry = new Map<string, DesignSystem>();

export function registerDesignSystem(ds: DesignSystem): void {
  registry.set(ds.id, ds);
}

export function getDesignSystem(id: string): DesignSystem | undefined {
  return registry.get(id);
}

export function listDesignSystems(): readonly DesignSystem[] {
  return [...registry.values()];
}

/** The fallback design system id when a site doesn't specify one. */
export const DEFAULT_DESIGN_SYSTEM_ID = "duro";
